import Cookies from "js-cookie"

export const handleSwissCTAClick = (router) => {
  const targetLanguage = "German"
  const tutor = "Anna (Switzerland)"
  const topic = "Open Conversation"
  const nativeLanguage = (navigator.language || "en").split("-")[0]

  Cookies.set("nativeLanguage", nativeLanguage, { path: "/" })
  Cookies.set("targetLanguage", targetLanguage, { path: "/" })
  Cookies.set("selectedTutor", tutor, { path: "/" })
  Cookies.set("onboardingComplete", "true", { path: "/" })

  router.push(
    `/app?targetLanguage=${targetLanguage}&tutor=${encodeURIComponent(
      tutor
    )}&topic=${encodeURIComponent(topic)}`
  )
}

export const handleDefaultCTAClick = (router) => {
  router.push("/app")
}

// asd
